<script lang="ts">
  import Redo from '~icons/mdi/redo';
  import Pill from '../components/Pill.svelte';

  type Props = { turns: number };
  export const { turns }: Props = $props();
</script>

<Pill value={turns} class="green">
  <Redo size={24} />
</Pill>
